import React from 'react';
import { Popconfirm, Button } from 'antd';
import PropTypes from 'prop-types';

/**
 * @param {placement} string set the position example "topRight", "left"
 * @param {title} string Popconfirm title
 * @param {okText} string Confirmation button text
 * @param {cancelText} string Cancel button text
 * @param {onConfirm} function onConfirm button function
 * @param {onCancel} function onCancel button function
 * @param {buttonType} string Button style, example "link"
 * @param {buttonText} string Button text
 */

const PopConfirm = ({ ...props }) => {
  return (
    <Popconfirm
      placement={props.placement}
      title={props.title}
      okText={props.okText}
      cancelText={props.cancelText}
      onConfirm={props.onConfirm}
      onCancel={props.onCancel}
    >
      <Button type={props.buttonType}>{props.buttonText}</Button>
    </Popconfirm>
  );
};

PopConfirm.propTypes = {
  placement: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  okText: PropTypes.string.isRequired,
  cancelText: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  buttonType: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
};

export default PopConfirm;